import { Navigate, useMatchRoute } from "@tanstack/react-router";

/** Sends a workstation URL to the same page on the front desk, or to the desk itself. */
export const FrontDeskRedirect = () => {
  const matchRoute = useMatchRoute();

  const patient = matchRoute({ to: "/patients/$patientId" });
  if (patient) {
    return (
      <Navigate
        to="/display/front-desk/patients/$patientId"
        params={{ patientId: patient.patientId }}
        replace
      />
    );
  }
  if (matchRoute({ to: "/schedule" })) {
    return <Navigate to="/display/front-desk/schedule" search replace />;
  }
  if (matchRoute({ to: "/calls" })) {
    return <Navigate to="/display/front-desk/calls" replace />;
  }
  if (matchRoute({ to: "/email" })) {
    return <Navigate to="/display/front-desk/email" search replace />;
  }
  return <Navigate to="/display/front-desk" replace />;
};
